// "Partes desta aba" (0.65, Texto 3 D): cada aba de fichas tem partes (Turmas, Alunos, Chamada, Cobranças...).
// A pessoa escolhe quais usa; as outras somem da tela (os dados continuam guardados). Na primeira vez que abre a aba,
// o app pergunta. Vale para as partes do topo e para as de dentro de cada ficha.
import { setDoc, useDoc } from '../store/store';
import type { ModId } from '../store/types';
import { DEFS } from '../modulos/defs';

/** Partes que dá para esconder: as que não são a única da tela em que aparecem. */
export function partesDaAba(mod: ModId) {
  const cols = DEFS[mod].colecoes;
  const irmas = (pai?: string) => cols.filter(c => c.pai === pai);
  return cols.filter(c => irmas(c.pai).length > 1);
}
export const temPartes = (mod: ModId) => partesDaAba(mod).length > 0;

/** A parte está ligada? Desligada a parte ou qualquer parte de cima dela (ex.: Recebimentos dentro de "Onde trabalho"),
 *  os itens somem também das caixinhas do My Planner (nada é apagado). */
export function parteLigada(ocultas: Partial<Record<ModId, string[]>> | undefined, mod: ModId, col: string) {
  const fora = ocultas?.[mod];
  if (!fora?.length) return true;
  const cols = DEFS[mod].colecoes;
  for (let c = cols.find(x => x.id === col), n = 0; c && n < 10; c = c.pai ? cols.find(x => x.id === c!.pai) : undefined, n++)
    if (fora.includes(c.id)) return false;
  return true;
}

export function usePartes(mod: ModId) {
  const aj = useDoc('ajustes');
  const ocultas = new Set(aj.partesOcultas?.[mod] ?? []);
  return {
    ocultas,
    visivel: (col: string) => !ocultas.has(col),
    perguntado: !!aj.partesPerguntadas?.includes(mod),
  };
}
export function mudarParte(mod: ModId, col: string, mostrar: boolean) {
  setDoc('ajustes', d => {
    const atual = new Set(d.partesOcultas?.[mod] ?? []);
    if (mostrar) atual.delete(col); else atual.add(col);
    return { ...d, partesOcultas: { ...(d.partesOcultas ?? {}), [mod]: [...atual] } };
  });
}
export function marcarPerguntado(mod: ModId) {
  setDoc('ajustes', d => ({ ...d, partesPerguntadas: [...new Set([...(d.partesPerguntadas ?? []), mod])] }));
}
